export default function Hero() {
  return (
    <section
      id="hero"
      className="relative pt-20 md:pt-24 pb-14 md:pb-20 overflow-hidden bg-background-50"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold tracking-wide mb-5 whitespace-nowrap">
              全网完结漫画聚合平台
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight">
              迷妹漫画
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-primary-500 mt-1">
                完结漫画一站补完
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 mt-5 leading-relaxed max-w-xl mx-auto lg:mx-0">
              迷妹漫画网专注聚合漫画全集与完结漫画完整版资源，覆盖热血、恋爱、悬疑、日常等全品类完结漫画大全。无论你是追更多年的老漫迷还是刚入坑的新读者，这里都能让你一次性刷完大结局，享受竖屏连续滚动阅读的畅快体验。每日更新完结漫画推荐榜单，帮你快速发现值得补完的经典作品。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>每日更新完结榜单</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>覆盖 30+ 漫画品类</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>竖屏连续滚动阅读</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热门完结漫画
              </a>
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-primary-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索话题分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cozy%20warm%20reading%20nook%20with%20stacked%20manga%20books%20and%20comics%2C%20soft%20warm%20ambient%20lighting%20from%20a%20nearby%20lamp%2C%20comfortable%20armchair%2C%20Japanese%20manga%20aesthetic%2C%20illustration%20style%20with%20rich%20warm%20coral%20and%20cream%20tones%2C%20clean%20artistic%20composition%2C%20cozy%20atmosphere%2C%20no%20text%20visible%2C%20artistic%20rendering&width=800&height=600&seq=hero-manga-01&orientation=landscape"
                alt="迷妹漫画 - 温暖舒适的漫画阅读角落"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}